// Public details of the platform shown on the marketing site. Set them in
// frontend/.env (VITE_SUPPORT_EMAIL=..., VITE_SUPPORT_WHATSAPP=96890000000);
// anything left empty is simply not shown.
const env = import.meta.env || {}

export const SITE = {
  name: env.VITE_SITE_NAME || 'Rawaj Business',
  company: env.VITE_COMPANY_NAME || env.VITE_SITE_NAME || 'Rawaj Business',
  email: env.VITE_SUPPORT_EMAIL || '',
  whatsapp: (env.VITE_SUPPORT_WHATSAPP || '').replace(/\D/g, ''),
  phone: env.VITE_SUPPORT_PHONE || '',
  city: env.VITE_COMPANY_CITY || 'Muscat, Sultanate of Oman',
  instagram: env.VITE_INSTAGRAM_URL || '',
  // Shown in the website mock-ups (yourstore.<domain>): the main site's own domain.
  domain: env.VITE_APP_DOMAIN || (typeof window !== 'undefined' && !/localhost|127\.0\.0\.1/.test(window.location.hostname) ? window.location.hostname.replace(/^www\./, '') : 'rawajbusiness.com'),
  // The date the legal pages were last changed.
  legalUpdated: '2026-10-02',
}
